/**
 * Anecdotes API - Integration Environment
 * Anecdotes API's
 *
 * OpenAPI spec version: 0.0.3
 * Contact: apiteam@anecdotes.ai
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Audit } from './audit';

export interface ExcludePlugin {
  [key: string]: string[];
}

export interface FrameworkAuditorControlStatus {
  [key: string]: boolean;
}

export interface FrameworkAuditorEvidenceStatus {
  [key: string]: boolean;
}

export interface Framework {
  /**
   * whether this framework applicable or not
   */
  is_applicable?: boolean;
  /**
   * the framework id
   */
  framework_id?: string;
  /**
   * the framework name
   */
  framework_name?: string;
  /**
   * The current status for this framework (AVAILABLE/COMINGSOON)
   */
  framework_status?: string;
  /**

   * The description of this framework
   */
  framework_description?: string;
  /**

   * number of controls that related to this framework
   */
  number_of_related_controls?: number;
  framework_reference_field_name?: string;
  /**
   * list of framework references
   */
  framework_references?: Array<string>;
  /**
   * whether this framework auditable or not
   */
  framework_auditable?: boolean;
  framework_current_audit?: Audit;

  /**
   * The overriden framework id
   */
  framework_icon_id?: string;
  /**
   * Excluded plugins from framework
   */
  framework_excluded_plugins?: ExcludePlugin;

  related_controls_snapshots?: string[];

  snapshot_id?: string;

  is_snapshot?: boolean;
  /**
   * object of allowed control statuses for the auditor - the status is the key, and whether its enabled is the value
   */
  framework_auditor_control_status?: FrameworkAuditorControlStatus;
  /**
   * object of allowed evidence statuses for the auditor - the status is the key, and whether its enabled is the value
   */
  framework_auditor_evidence_status?: FrameworkAuditorEvidenceStatus;

  /**
   * defines which references are applied to framework
   */
  references?: { [reference_name: string]: boolean };

  framework_controls_categories?: string[];

  /**
   * If truthy then the auditor should be able to download evidence related to this framework
   */
  can_auditor_download_evidence?: boolean;

  can_auditor_view_tags?: boolean;

  is_soc2_like?: boolean;

  can_auditor_view_control_custom_fields?: boolean;

  can_auditor_view_control_attachments?: boolean;
  can_auditor_view_soa_report?: boolean;
}

export function is_custom_framework(framework: Framework): boolean {
  return framework.framework_id.startsWith('framework');
}
